import Languages from '../constants/Languages';
import { Language, languageCode } from '../types/Languages';

/**
 * Fetch a translation and replace any {{parameters}} with the strings provided
 */
export function pureTranslate(
  locale: languageCode,
  allTranslations: { [l: string]: { [k: string]: string } },
  key: string,
  defaultMessage?: string,
  params?: { [k: string]: string }
): string | undefined {
  // Fall back to default message even if undefined
  // @see https://jsonforms.io/docs/i18n/#:~:text=If%20the%20defaultMessage,could%20be%20tried
  let translation: string | undefined = allTranslations[locale]?.[key] ?? defaultMessage;

  if (translation !== undefined && params !== undefined) {
    for (const param in params) {
      translation = translation.replaceAll(`{{${param}}}`, params[param]);
    }
  }

  return translation;
}

export function localization(language: Language) {
  const locale = language?.name || 'en';

  const translate = (key: string, params?: { [k: string]: string }): string => {
    // Look up translated key, attempting to fall back to English if none is found.
    // If no English either, fall back to empty string.
    return pureTranslate(locale, Languages.translations, key, Languages.translations.en[key], params) ?? '';
  };

  return {
    locale,
    translation: Languages.translations[locale],
    t: translate,
  };
}
